import { Component, Input } from '@angular/core';
import { ToastService } from '../../../shared/services/toast.service';
import { OrderService } from '../../../orders/services/order.service';
import { OrderSharedService } from '../../../orders/services/order-shared.service';
declare var $: any;

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html'
})
export class ViewImageComponent {

  @Input() imgIsWebUploaded: boolean;
  @Input() img: string

  constructor(
    private _orderService: OrderService,
    private _toast: ToastService,
    private _shared: OrderSharedService
  ) { 

    this._toast.toastId = this.constructor.name;
  }

  // DELETE IMAGES UPLOADED FROM THE WEB APP
  DeleteOrderPictures() {
    this._orderService.DeleteOrderImages(this.img).subscribe({
      next: () => {
        $('#showImage').modal('hide');
        this._toast.ShowToast('success');
        this._shared.reloadAllOrderImgsEvent.emit(this.img);
      }
    })
  }

}
